import React from "react"
import { Link } from "react-router-dom"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"

import TeacherInfoHeader from "./TeacherInfoHeader"
import TeacherJobListContents from "../Bookings2/TeacherJobListContents"
import TeacherJobListNewContent from "../Bookings2/TeacherJobListNewContent"

class TeacherJoblist extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // user: JSON.parse(window.localStorage.getItem("teacher"))
      user: JSON.parse(window.sessionStorage.getItem("admin-check-teacher")),
      allBookings: [],
      showBookings: [],
      allCampuses: [],
      allInsts: [],
      allClasses: []
    }
    if (this.state.user === null) {
      window.location = "/login"
    }
  }

  render() {
    return (
      <AdminWrapper>
        <SwitchMenuBar isViewAsTeacher />

        <div className="auth-right d-lg-flex bg-photoregister ">
          <div className="bg-gradient"></div>
          <div className="profile-container">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <div className="page-container-header" style={{ position: "initial", height: 100}}>
                  <TeacherInfoHeader user={this.state.user} />
                </div>
                <div className="mt-5">

                  {/* navigationbar on top */}
                  <div className="userNavigation d-flex justify-content-between">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
                    >
                      <p>BACK</p>
                    </Link>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherNotes"
                          }
                        }
                        className="user-links  user-links-active d-flex user-links-background-transparent "
                      >
                        <p>Team Notes</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={
                          {
                            pathname: "/TeacherpersonalDetails"
                          }
                        }
                        className="user-links d-flex user-links-background-transparent "
                      >
                        <p>P.Info/I.D.</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherBanking",
                        }}
                        className="user-links text-center d-flex  "
                      >
                        <p>Banking</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/validatedocuments",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Uploads</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          pathname: "/TeacherCalendar",
                        }}
                        className="user-links text-center d-flex "
                      >
                        <p>Calendar</p>
                      </Link>
                    </div>
                    <div className="behind-user-links">
                      <Link
                        to={{
                          //pathname: "/TeacherJoblist",
                        }}
                        className="user-links user-links-active text-center d-flex "
                      >
                        <p>JobList</p>
                      </Link>
                    </div>
                  </div>


                  {/* <div className="availability-table-container">
                    <div className="availability-table">
                      <div className="availability-table-body mb-5">
                        <div className="availability-table-body-content">
                          {(this.state.allBookings.length == 0 || this.state.allCampuses.length == 0) ? (
                            <p className="text-center mb-5">
                              Currently there is no data available.
                            </p>
                          ) : (
                            <>
                              {this.state.allBookings.map((job) => {
                                const jobCampus = this.state.allCampuses.find(campus => campus._id === job.campus_id);
                                const jobInst = jobCampus ? this.state.allInsts.find(inst => inst._id === jobCampus.institution_id) : null;
                                return <>
                                  <JobBoardComponent
                                    job={job}
                                    // campuses={allCampus}
                                    campus={jobCampus}
                                    // insts={allInst}
                                    inst={jobInst}
                                  />
                                  <hr className="qualification-line-1 mb-3" />
                                </>
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>
                    <TeacherJobListNewContent
                      user={this.state.user}
                      isViewAsAdmin
                    />
                  </div>

                  {/* navigationbar on bottom */}
                  <div className="adminBottomNavigation ">
                    <Link
                      to={{
                        pathname: "/AllTeachers",
                      }}
                      className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                    >
                      <p>BACK - All Teachers</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminWrapper>
    )
  }
}

export default TeacherJoblist;
